import React, {useEffect, useMemo, useState} from 'react'
import {useUtils} from '@mui/lab/internal/pickers/hooks/useUtils'
import dateMasks from '../localization/date-masks'
import {Action, ComplaintState, Customer, CustomerAddress} from './types'
import {AlertColor} from "@mui/material";
import useComplaintReducer from "./useComplaintReducer";

type AppContextState = {
    shouldClearSessionAfterSubmission: boolean
    dateMask: string
    progress: number
    setProgress: React.Dispatch<number>
    customer: Customer
    setCustomer: React.Dispatch<Customer>
    addresses: CustomerAddress[]
    setAddresses: React.Dispatch<CustomerAddress[]>
    complaint: ComplaintState
    dispatch: React.Dispatch<Action>
    loggedIn: boolean
    setLoggedIn: React.Dispatch<boolean>,
    countryCode: string
    customerNumber: string
    postNotification: (color: AlertColor, message: string) => void
    clearNotification: () => void
    notification?: [AlertColor, string]
}

export const AppContext = React.createContext<AppContextState>({} as AppContextState)

type AppContextProviderProps = {
    shouldClearSessionAfterSubmission: boolean
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({
                                                                          shouldClearSessionAfterSubmission,
                                                                          children
                                                                      }) => {
    const utils = useUtils()
    const [progress, setProgress] = useState<number>(0)
    const [customer, setCustomer] = useState<Customer>({} as Customer)
    const [addresses, setAddresses] = useState<CustomerAddress[]>([])
    const [dateMask] = useState<string>(() => dateMasks[utils.getCurrentLocaleCode()])
    const [notification, setNotification] = useState<[AlertColor, string]>()
    const [complaint, dispatch] = useComplaintReducer()
    const [loggedIn, setLoggedIn] = useState<boolean>(false);
    const countryCode = useMemo(() => ((loggedIn ? customer.country : complaint.guestInfo.country) || '').toLowerCase(), [customer.country, complaint.guestInfo.country, loggedIn])
    const customerNumber = useMemo(() => complaint.shippingInfo.customer?.customer || customer.customer, [complaint.shippingInfo.customer, customer.customer])

    useEffect(() => {
        sessionStorage.setItem('complaintData', JSON.stringify(complaint))
    }, [complaint])

    return (
        <AppContext.Provider
            value={{
                shouldClearSessionAfterSubmission,
                dateMask,
                progress,
                setProgress,
                customer,
                setCustomer,
                addresses,
                setAddresses,
                complaint,
                dispatch,
                loggedIn,
                setLoggedIn,
                countryCode,
                customerNumber,
                postNotification: (color, message) => setNotification([color, message]),
                clearNotification: () => setNotification(undefined),
                notification
            }}
        >
            {children}
        </AppContext.Provider>
    )
}
